import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

interface RelatedPostsPanelProps {
  pillarSlug?: string;
  pillarLabel?: string;
  relatedPosts: Array<{ slug: string; title: string; excerpt: string }>;
}

const RelatedPostsPanel: React.FC<RelatedPostsPanelProps> = ({
  pillarSlug,
  pillarLabel,
  relatedPosts,
}) => {
  if (!pillarSlug) return null;

  return (
    <div className="mt-8 pt-8 border-t border-gray-200">
      {/* Pillar backlink banner — prominent, at top of panel */}
      <Link
        to={`/${pillarSlug}`}
        className="block bg-accent-50 border border-accent-300 rounded-xl p-4 mb-6 hover:shadow-sm transition-all"
      >
        <span className="inline-flex items-center gap-2 text-accent-600 hover:text-accent-700 font-semibold">
          Part of the {pillarLabel} guide
          <ArrowRight className="w-4 h-4" />
        </span>
      </Link>

      {/* Sibling posts — only rendered if > 0 */}
      {relatedPosts.length > 0 && (
        <>
          <h3 className="text-2xl font-heading font-bold text-gray-900 mb-6">
            Related Articles
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {relatedPosts.slice(0, 3).map((post) => (
              <div
                key={post.slug}
                className="border border-gray-200 rounded-xl p-5 hover:border-accent-300 hover:shadow-sm transition-all"
              >
                <h4 className="font-semibold text-gray-900 mb-2">
                  {post.title}
                </h4>
                <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                  {post.excerpt}
                </p>
                <Link
                  to={`/blog/${post.slug}`}
                  className="inline-flex items-center text-accent-600 hover:text-accent-700 font-medium text-sm transition-colors"
                >
                  Read More
                  <ArrowRight className="w-4 h-4 ml-1" />
                </Link>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default RelatedPostsPanel;
